(function () {
    'use strict';

    angular.module('plagiat2017App')
    .factory('queryRequest', function () {

        function queryRequest() {
            this.order = '-docuSubmitDate';
            this.page = 1;
            this.limit = 5;
            this.fixedHeader = 30;
            this.search = {};
        }

        return queryRequest;
    });
})();
